/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { DialogRef } from '@ngneat/dialog';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Store } from '@ngxs/store';
import { Profile, User } from 'rest-client';

import { UserService } from '@app/modules/core/services/user/user.service';
import { SetUserAction } from '@app/modules/core/states/auth-state/auth.actions';

@UntilDestroy()
@Component({
  selector: 'bkg-change-user-mode-dialog',
  templateUrl: './change-user-mode-dialog.component.html',
  styleUrls: ['./change-user-mode-dialog.component.scss'],
})
export class ChangeUserModeDialogComponent implements OnInit {
  constructor(
    public ref: DialogRef,
    private store: Store,
    private userService: UserService,
    private formBuilder: FormBuilder
  ) {}
  errorMessage: string | null;

  companyProfiles: Profile[];
  form: FormGroup;
  selectedProfileId: number;
  isBusinessMode: boolean;

  ngOnInit(): void {
    this.isBusinessMode = this.ref.data['businessMode'] as boolean;
    this.initForm();
    this.getCompanyProfiles();
  }

  private getCompanyProfiles(): void {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const profiles = this.ref.data['profiles'] as Profile[];
    const companyProfiles = profiles?.filter((profile: Profile) =>
      profile.hasOwnProperty('companyId')
    );
    this.companyProfiles = this.cleanProfiles(companyProfiles);

    // eslint-disable-next-line prefer-spread
    this.selectedProfileId = Math.max.apply(
      Math,
      this.companyProfiles?.map((profile: Profile) => {
        return +profile.id;
      })
    );

    this.form.controls.userCompany.setValue(+this.selectedProfileId);
  }

  private cleanProfiles(profiles: Profile[]): Profile[] {
    const returnedProfiles: Profile[] = [];
    profiles.forEach((profile: Profile) => {
      if (returnedProfiles.some((e: Profile) => e.nif === profile.nif)) {
        let change = false;
        const compare = profiles?.filter(
          (cprofile: Profile) => cprofile.nif === profile.nif
        )[0];
        if (profile.id_company && !compare.id_company) {
          change = true;
        } else if (
          profile.id_company &&
          compare.id_company &&
          profile.id > compare.id
        ) {
          change = true;
        } else if (
          !profile.id_company &&
          !compare.id_company &&
          profile.id > compare.id
        ) {
          change = true;
        }
        if (change) {
          const index = returnedProfiles
            ?.map((e: Profile) => e.nif)
            .indexOf(profile.nif);
          returnedProfiles.splice(index, 1);
          returnedProfiles.push(profile);
        }
      } else {
        returnedProfiles.push(profile);
      }
    });
    return returnedProfiles;
  }

  private initForm(): void {
    if (!this.form) {
      this.form = this.formBuilder.group({
        userCompany: [null, Validators.required],
      });
    }
  }

  onClickClose(): void {
    this.ref.close(false);
  }

  onCloseBanner(): void {
    this.errorMessage = null;
  }

  onSelectProfile(e: Event): void {
    this.selectedProfileId = +e;
  }

  selectCompanyProfile(deleteProfile?: string): void {
    const param = deleteProfile ? deleteProfile : this.selectedProfileId;

    this.userService
      .setDefaultInvoice(param)
      .pipe(untilDestroyed(this))
      .subscribe((user: User) => {
        //this.userService.setUserAtLocalStorage(user);
        this.store.dispatch(new SetUserAction(user));
        this.ref.close(false);
      });
  }
}
